export default "__VITE_ASSET__DeF3sE0y__"